import React from 'react';
import { Wrapper } from '../../components_desktop/css_global/utils.css';
import VerticalSpacer from '../VerticalSpacer';

const ReviewsExample = () => (
  <div>
    <Wrapper
      font={'"Avenir", "Arial", sans-serif'}
      fontSize="15px"
      fontWeight="900"
      letterSpacing="1px"
      lineHeight="20px"
      textAlign="center"
    >
      What insiders are saying
    </Wrapper>
    <VerticalSpacer height="20px" />
    <Wrapper
      font={'"Avenir", "Arial", sans-serif'}
      fontWeight="900"
      fontSize="13px"
      lineHeight="18px"
      letterSpacing="1px"
      textAlign="center"
    >
      Great shoes, fast shipping!
    </Wrapper>
    <Wrapper font={'"Avenir", "Arial", sans-serif'} fontWeight="300" fontStyle="oblique" textAlign="center">
      “I ordered the Stella McCartney Elyse sneaker, size 37, US size 7, the fit was perfect. I received them 2 days
      later. You can't beat that. They are divine. So many compliments. Not only that, I got them for a great price.
      Will definitely shop through Italist again.” – Lori M.
    </Wrapper>
  </div>
);

export default ReviewsExample;
